export default "__VITE_ASSET__DP1Oh4si__"